import React from 'react';
import '../Styles/CategoriesST.css';
import {useSelector, useDispatch} from 'react-redux';
import pasta from '../Icons/pasta.png';
import arroz from '../Icons/soup.png';
import suplementos from '../Icons/spicy.png';
import quesadillas from '../Icons/quesadilla.png';
import croquetas from '../Icons/croquette.png';
import postres from '../Icons/dessert.png';
import bebidas from '../Icons/drink.png';
import otros from '../Icons/plate.png';
import {simpleAction} from '../Redux/actions/simpleAction';

const Categories = props => {

    const CatToggler = useSelector(state=>state.categoriesToggler)

    const dispatch = useDispatch()

    return(
        <section className="Categories-container">
            <div className="content">
                <div className="Categoria">
                    <a className={
                        CatToggler.todo
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "todo"})}}>
                        <img src="Img/tenedor.png"></img>
                    </a>
                    <p className="name">Todo</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.burritos
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "burritos"})}}>
                        <img src="Img/burrito.png"></img>
                    </a>
                    <p className="name">Burritos</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.tacos
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "tacos"})}}>
                        <img src="Img/taco.png"></img>
                    </a>
                    <p className="name">Entrantes</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.enchiladas
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "enchiladas"})}}>
                        <img src="Img/enchilada.png"></img>
                    </a>
                    <p className="name">Enchiladas</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.nachos
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "nachos"})}}>
                        <img src="Img/nachos.png"></img>
                    </a>
                    <p className="name">Nachos</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.empanadas
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "empanadas"})}}>
                        <img src="Img/empanadillas.png"></img>
                    </a>
                    <p className="name">Empanadas</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.pasta
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "pasta"})}}>
                        <img src={pasta}></img>
                    </a>
                    <p className="name">Pasta</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.arroz
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "arroz"})}}>
                        <img src={arroz}></img>
                    </a>
                    <p className="name">Principales</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.suplementos
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "suplementos"})}}>
                        <img src={suplementos}></img>
                    </a>
                    <p className="name">Suplementos</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.quesadillas
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "quesadillas"})}}>
                        <img src={quesadillas}></img>
                    </a>
                    <p className="name">Vegetarianos</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.croquetas
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "croquetas"})}}>
                        <img src={croquetas}></img>
                    </a>
                    <p className="name">Croquetas</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.postres
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "postres"})}}>
                        <img src={postres}></img>
                    </a>
                    <p className="name">Postres</p>
                </div>
                <div className="Categoria">
                    <a className={
                        CatToggler.bebidas
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "bebidas"})}}>
                        <img src={bebidas}></img>
                    </a>
                    <p className="name">Bebidas</p>
                </div>
                <div id="hidden" className="Categoria">
                    <a className={
                        CatToggler.otros
                        ? "Link-icon-container-pressed"
                        : "Link-icon-container"
                    } onClick={()=>{dispatch({type: "otros"})}}>
                        <img src={otros}></img>
                    </a>
                    <p className="name">Otros</p>
                </div>
            </div>
            <div className="titlecontainer2">
                <div className="Products-container">Productos</div>
            </div>
            <div className="search-container">
                <div className="search-input">
                    <input type="text" placeholder="Buscar producto" onChange={(e)=>{dispatch(simpleAction('searchname', e.target.value));dispatch({type: "search"})}} onClick={(e)=>{dispatch({type: "search"})}}/>
                </div>
            </div>
        </section>
    )
}
export default Categories;